import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExpandablePanelComponent } from './expandable-panel.component';

@NgModule({
    imports: [CommonModule],
    exports: [ExpandablePanelComponent],
    declarations: [ExpandablePanelComponent]
})
export class ExpandablePanelModule {}
